import React, { Component } from 'react';
import { Link } from 'react-router';
import Aside from '@music/ct-creator-asidebar';
import styles from './aside.less';
import history from './util/history';

// eslint-disable-line no-unused-vars
class AsideContainer extends Component {
    constructor(props) {
        super(props);
    }

    show() {
        this.refs.aside.show();
    }

    render() {
        return (
            <div className="g-aside">
                <div className="m-aside-content">
                    <Aside
                        history={history}
                        old={false}
                        width={270}
                        ref="aside"
                        historyType="browser"
                        link={Link} />
                </div>
            </div>
        );
    }
}

export default AsideContainer;



// WEBPACK FOOTER //
// ./client/aside.js